import { Link } from "react-router-dom";
import pompageImg from "../../images/pompage.png";
import { Card, CardContent, CardHeader } from "../ui/card";
const CardContentData = [
  {
    id: "1",
    icon: "1",
    title: "pompage  ",
    desc: (
      <p>
        {" "}
        Une fois contrôlée L’eau brute provient de la nappe phréatique de
        Croissy-sur-Seine. Cette nappe, insuffisamment alimentée de façon
        naturelle, bénéficie d’une{" "}
        <span className="font-bold">réalimentation artificielle</span> à partir
        d’eau de la Seine. L’eau est préalablement traitée par voie
        physico-chimique puis par voie biologique. Elle est ensuite réinfiltrée
        très lentement dans d’anciennes sablières spécialement aménagées. Cette
        réalimentation permet de{" "}
        <span className="font-bold">
          faire face à l’augmentation des débits pompés et d’améliorer la
          qualité de l’eau sur l’ensemble de la nappe
        </span>{" "}
        .Onze forages de 30 à 60 mètres de profondeur permettent de prélever les
        quantités nécessaires à tout moment. La station de pompage de Bougival
        relève l’eau brute jusqu’aux bassins des Deux Portes et de Louveciennes.
        L’eau acheminée par la station est ensuite traitée à{" "}
        <span className="font-bold text-primary group-hover:text-white">
          {" "}
          l’usine de Louveciennes.{" "}
        </span>
      </p>
    ),
  },

  {
    id: "2",
    icon: "2",
    title: "production",
    desc: (
      <p>
        {" "}
        À Louveciennes, l’eau suit plusieurs traitements :{" "}
        <span className="font-bold">tamisage et filtration</span> (pour retenir
        les impuretés, particules organiques et produits chimiques),
        <Link
          to="/water?adoucissement"
          className="font-bold text-primary group-hover:text-white"
          target="_blank"
        >
          décarbonatation 
        </Link>
        (pour adoucir l’eau par élimination d’une partie du
        calcaire), ozonation (pour détruire les germes et virus par diffusion
        d‘ozone), et chloration (pour désinfecter à l’aide de chlore).
      </p>
    ),
  },

  {
    id: "3",
    icon: "3",
    title: "STOCKAGE ET DISTRIBUTION",
    desc: (
      <p>
        Une fois contrôlée, l’eau potable est transportée jusqu’à des réservoirs
        enterrés et des châteaux d’eau, où elle est stockée avant sa
        distribution jusqu’aux robinets.
      </p>
    ),
  },
];

const MissionWater = () => {
  return (
    <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
      <h1 className="font-bold text-center text-primary">EAU POTABLE</h1>
      <p className="mt-2 text-center">
        EAU POTABLE Captage de l’eau brute, traitement et production d’eau
        potable, distribution à l’usager… <br />
        AQUAVESC est un acteur essentiel du cycle de l’eau de l’ouest parisien.
      </p>

      <div className="flex justify-center mt-10 mb-10">
        <img src={pompageImg} alt="" />
      </div>

      <div className="flex flex-col justify-center mt-10 space-y-5 lg:space-x-0 lg:mt-10 lg:flex-col">
        {CardContentData.map((item, index) => (
          <Card
            key={item.id}
            className="hover:bg-[#3CC6F7] group w-full bg-[#f0fafe]"
          >
            <CardHeader></CardHeader>
            <CardContent className="">
              <div className="flex">
                <div className="w-1/6">
                  {" "}
                  <div
                    className={`w-[70px] h-[94px] bg-[url('/src/images/vector.svg')] group-hover:bg-[url('/src/images/vectorHover.svg')] mt-5`}
                  >
                    <div className="relative w-full h-[37px] top-[21px] left-[21px] flex justify-center">
                      <div className="absolute top-[17px]  left-[6px]  font-bold text-2xl    text-white ">
                        {item.icon}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full ml-5">
                  {" "}
                  <p className="mt-3 font-bold group-hover:text-white ">
                    {item.title.charAt(0).toUpperCase() + item.title.slice(1)}
                  </p>
                  <p className=" group-hover:text-white"> {item.desc}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MissionWater;
